import * as React from 'react';
import { Tooltip } from 'antd';
import { inject, injectable } from 'inversify';

interface TooltipViewProps {
	title: string | any;
	placement?: 'top' | 'left' | 'right' | 'bottom'
	| 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight'
	| 'leftTop' | 'leftBottom' | 'rightTop' | 'rightBottom';
	trigger?: 'hover' | 'focus' | 'click';
}

/**
 * Tooltip. Please ensure that the child node of Tooltip accepts onMouseEnter, onMouseLeave, onFocus, onClick events.
 */
@injectable()
export class TooltipView extends React.Component<TooltipViewProps, any> {
    render() {
		return (
			<Tooltip
				title={this.props.title}
				placement={this.props.placement}
				arrowPointAtCenter={true}>
				{this.props.children}
			</Tooltip>
		);
    }
}



// WEBPACK FOOTER //
// ./src/core/ui/tooltip.view.tsx